import { useEffect } from 'react';
import type { Experiments } from '@wix/yoshi-flow-editor';
import { ExperimentsConsts } from '../../../consts/experiments';
import { FormStatus } from '../../../types/form-state';
import type { SetFormStatus } from '../Actions/setFormStatus/setFormStatus';

/**
 * Resets the form status when the page is restored from bfcache (browser back
 * after MPA navigation to checkout), otherwise the global loader stays stuck.
 */
export const useBfcacheStatusReset = ({
  status,
  setFormStatus,
  experiments,
}: {
  status: FormStatus;
  setFormStatus: SetFormStatus;
  experiments: Experiments;
}) => {
  const isEnabled = experiments.enabled(
    ExperimentsConsts.FormBfcacheStatusReset,
  );

  useEffect(() => {
    if (!isEnabled) {
      return;
    }

    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted && status === FormStatus.PROCESSING_SUBMIT_ACTION) {
        setFormStatus(FormStatus.IDLE);
      }
    };

    window.addEventListener('pageshow', handlePageShow);

    return () => {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, [status, setFormStatus, isEnabled]);
};
